/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserImage,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsUserImageToJSON,
    SharedserviceMelcoModelsImageReferences,
    SharedserviceMelcoModelsImageReferencesFromJSON,
    SharedserviceMelcoModelsImageReferencesToJSON,
    SharedserviceMelcoModelsUserImage,
    SharedserviceMelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsUserImageToJSON,
} from '../models';

export interface ImagesDraftApiUserImageDeleteRequest {
    id: string;
    force?: boolean;
}

export interface ImagesDraftApiUserImageDownloadRequest {
    id: string;
    publishState?: string;
}

export interface ImagesDraftApiUserImageDuplicateDraftRequest {
    id: string;
}

export interface ImagesDraftApiUserImageGetDefRequest {
    id: string;
    publishState?: string;
}

export interface ImagesDraftApiUserImagePreviewRequest {
    id: string;
    width?: number;
    publishState?: string;
}

export interface ImagesDraftApiUserImagePublishRequest {
    id: string;
}

export interface ImagesDraftApiUserImageReferencesRequest {
    id: string;
}

export interface ImagesDraftApiUserImageRevertRequest {
    id: string;
}

export interface ImagesDraftApiUserImageSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

export interface ImagesDraftApiUserImageUpdateDraftRequest {
    id: string;
    name?: string;
    viewName?: string;
    colorName?: string;
    colorHex?: string;
    file?: Blob;
}

export interface ImagesDraftApiUserImageUploadDraftRequest {
    name?: string;
    viewName?: string;
    colorName?: string;
    colorHex?: string;
    file?: Blob;
}

/**
 * 
 */
export class ImagesDraftApi extends runtime.BaseAPI {

    /**
     */
    async userImageDeleteRaw(requestParameters: ImagesDraftApiUserImageDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userImageDelete(requestParameters: ImagesDraftApiUserImageDeleteRequest): Promise<void> {
        await this.userImageDeleteRaw(requestParameters);
    }

    /**
     */
    async userImageDownloadRaw(requestParameters: ImagesDraftApiUserImageDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userImageDownload(requestParameters: ImagesDraftApiUserImageDownloadRequest): Promise<Blob> {
        const response = await this.userImageDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageDuplicateDraftRaw(requestParameters: ImagesDraftApiUserImageDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserImage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImageDuplicateDraft(requestParameters: ImagesDraftApiUserImageDuplicateDraftRequest): Promise<SharedserviceMelcoModelsUserImage> {
        const response = await this.userImageDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageGetDefRaw(requestParameters: ImagesDraftApiUserImageGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserImage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImageGetDef(requestParameters: ImagesDraftApiUserImageGetDefRequest): Promise<SharedserviceMelcoModelsUserImage> {
        const response = await this.userImageGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImagePreviewRaw(requestParameters: ImagesDraftApiUserImagePreviewRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImagePreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userImagePreview(requestParameters: ImagesDraftApiUserImagePreviewRequest): Promise<void> {
        await this.userImagePreviewRaw(requestParameters);
    }

    /**
     */
    async userImagePublishRaw(requestParameters: ImagesDraftApiUserImagePublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserImage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImagePublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImagePublish(requestParameters: ImagesDraftApiUserImagePublishRequest): Promise<SharedserviceMelcoModelsUserImage> {
        const response = await this.userImagePublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageReferencesRaw(requestParameters: ImagesDraftApiUserImageReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsImageReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsImageReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userImageReferences(requestParameters: ImagesDraftApiUserImageReferencesRequest): Promise<SharedserviceMelcoModelsImageReferences> {
        const response = await this.userImageReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageRevertRaw(requestParameters: ImagesDraftApiUserImageRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userImageRevert(requestParameters: ImagesDraftApiUserImageRevertRequest): Promise<void> {
        await this.userImageRevertRaw(requestParameters);
    }

    /**
     */
    async userImageSearchRaw(requestParameters: ImagesDraftApiUserImageSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsUserImage>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/images`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImageSearch(requestParameters: ImagesDraftApiUserImageSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsUserImage> {
        const response = await this.userImageSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageUpdateDraftRaw(requestParameters: ImagesDraftApiUserImageUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserImage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userImageUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name as any);
        }

        if (requestParameters.viewName !== undefined) {
            formParams.append('view_name', requestParameters.viewName as any);
        }

        if (requestParameters.colorName !== undefined) {
            formParams.append('color_name', requestParameters.colorName as any);
        }

        if (requestParameters.colorHex !== undefined) {
            formParams.append('color_hex', requestParameters.colorHex as any);
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/images/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImageUpdateDraft(requestParameters: ImagesDraftApiUserImageUpdateDraftRequest): Promise<SharedserviceMelcoModelsUserImage> {
        const response = await this.userImageUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userImageUploadDraftRaw(requestParameters: ImagesDraftApiUserImageUploadDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsUserImage>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name as any);
        }

        if (requestParameters.viewName !== undefined) {
            formParams.append('view_name', requestParameters.viewName as any);
        }

        if (requestParameters.colorName !== undefined) {
            formParams.append('color_name', requestParameters.colorName as any);
        }

        if (requestParameters.colorHex !== undefined) {
            formParams.append('color_hex', requestParameters.colorHex as any);
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/images/upload/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsUserImageFromJSON(jsonValue));
    }

    /**
     */
    async userImageUploadDraft(requestParameters: ImagesDraftApiUserImageUploadDraftRequest): Promise<SharedserviceMelcoModelsUserImage> {
        const response = await this.userImageUploadDraftRaw(requestParameters);
        return await response.value();
    }

}
